function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if(summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    var target = event.target;
    var header = target.closest('#shopify-section-header')
    var details = target.closest('details')
    var isMegaMenu = details.classList.contains('mega-menu')
    var body = document.querySelector('body')
    if (isMegaMenu) {
      if (header !== null) {
        if (body.classList.contains('mega--menu_overlay')) {
          body.classList.remove('mega--menu_overlay')
        } else {
          body.classList.add('mega--menu_overlay')
        }
      }
    }
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    if (details !== null) {
      var megaMenu = details.querySelector('.mega-menu__content')
      if (megaMenu !== null) {
        if (details.hasAttribute('open')) {
          megaMenu.classList.remove('fade')
        } else {
          megaMenu.classList.add('fade')
        } 
      }
    }
  });

  if (summary.closest('header-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function() {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function(event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch(e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if(navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener('focus', () => {
    if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

    if (mouseClick) return;

    currentFocusedElement = document.activeElement;
    currentFocusedElement.classList.add('focused');

  }, true);
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;
  var body = document.querySelector('body')
    if (body.classList.contains('mega--menu_overlay')) {
      body.classList.remove('mega--menu_overlay')
    }
  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true })

    this.querySelectorAll('button').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    var priceNode = document.querySelector('.price__regular .price-item--regular')
    const previousValue = this.input.value;
    const basePrice = parseInt(event.target.closest('quantity-input').dataset.price, 10)
    if (event.target.name === 'plus') {
      this.input.stepUp()
      const currentValue = parseInt(event.target.closest('quantity-input').querySelector('input').value, 10)
      var price = window.custom.Currency.formatMoney((currentValue * basePrice), window.custom.moneyFormat)
      if(priceNode !== null) priceNode.innerHTML = price
    } else {
       this.input.stepDown()
      const currentValue = parseInt(event.target.closest('quantity-input').querySelector('input').value, 10)
        var price = window.custom.Currency.formatMoney((currentValue * basePrice), window.custom.moneyFormat)
        if(priceNode !== null) priceNode.innerHTML = price
    }
    if (custom.template === 'product.product-quantity') {
        const currentValue = parseInt(event.target.closest('quantity-input').querySelector('input').value, 10)
        var text = `Add ${currentValue} to cart`
        var btn_text = document.querySelector('button.product-form__submit span')
        console.log(btn_text)
        btn_text.innerHTML = text 
    }
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function(fn, scope) {
  return function() {
    return fn.apply(scope, arguments);
  }
};

Shopify.setSelectorByValue = function(selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function(target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on'+eventName, callback);
};

Shopify.postLink = function(path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for(var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function(country_domid, province_domid, options) {
  this.countryEl         = document.getElementById(country_domid);
  this.provinceEl        = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler,this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function() {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function() {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function(e) {
    var opt       = this.countryEl.options[this.countryEl.selectedIndex];
    var raw       = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function(selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function(selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
    this.querySelectorAll('button').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
  }

  onKeyUp(event) {
    if(event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if(!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if(isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);

      if (window.matchMedia('(max-width: 990px)')) {
        document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches ? addTrapFocus() : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach(details => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach(submenu => {
      submenu.classList.remove('submenu-open');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    }

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.getElementById('shopify-section-header');
    this.borderOffset = this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);
    this.header.classList.add('menu-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
  }
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this, false)
    );
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver(entries => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor((this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset);
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(new CustomEvent('slideChanged', { detail: {
        currentPage: this.currentPage,
        currentElement: this.sliderItemsToShow[this.currentPage - 1]
      }}));
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return (element.offsetLeft + element.clientWidth) <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition = event.currentTarget.name === 'next' ? this.slider.scrollLeft + (step * this.sliderItemOffset) : this.slider.scrollLeft - (step * this.sliderItemOffset);
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach(link => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
    this.autoplaySpeed = this.slider.dataset.speed * 1000;

    this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    this.play();
    this.autoplayButtonIsSetToPlay = true;
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) return;

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach(link => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
    this.play();
  }

  focusInHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
      this.play();
    } else if (this.autoplayButtonIsSetToPlay) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition = this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.slider.querySelector('.slideshow__slide').clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }

  setSlideVisibility() {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll('a');
      if (index === this.currentPage - 1) {
        if (linkElements.length) linkElements.forEach(button => {
          button.removeAttribute('tabindex');
        });
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (linkElements.length) linkElements.forEach(button => {
          button.setAttribute('tabindex', '-1');
        });
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
  }

  connectedCallback() {
    // Initialisiere die Bildanzeige beim Laden der Komponente
    this.initializeImageDisplay();
  }

  initializeImageDisplay() {
    // Warte kurz, damit alle Elemente geladen sind
    setTimeout(() => {
      // Prüfe ob eine Variante ausgewählt ist
      this.updateOptions();
      this.updateMasterId();
      
      if (!this.currentVariant) {
        // Keine Variante ausgewählt - zeige alle Bilder
        this.showAllImages();
      } else {
        // Variante ausgewählt - filtere Bilder
        this.filterImagesByVariantName();
      }
    }, 100);
  }

  onVariantChange() {
    console.log('=== VARIANT CHANGE EVENT ===');
    this.updateOptions();
    console.log('📝 Options after update:', this.options);
    this.updateMasterId();
    console.log('📝 Current variant after updateMasterId:', this.currentVariant);
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();

    console.log('Current variant after update:', this.currentVariant);

    if (!this.currentVariant) {
      console.log('No variant selected - showing all images');
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
      // Zeige alle Bilder an, wenn keine Variante ausgewählt ist
      this.showAllImages();
    } else {
      console.log('Variant selected - filtering images:', this.currentVariant.title);
      this.updateVariantInput();
      this.updateURL(); // ✅ WICHTIG: VOR updateMedia() aufrufen!
      this.updateShareUrl();
      this.renderProductInfo();
      
      // ✅ EINFACHSTE LÖSUNG: Page Refresh nach URL-Update
      setTimeout(() => {
        console.log('🔄 Refreshing page to show filtered gallery...');
        window.location.reload();
      }, 100);
      
      // this.updateMedia(); // ← Nicht mehr nötig, da Page Refresh
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;

    // WICHTIG: Filtere Bilder IMMER, auch wenn keine featured_media
    console.log('🎬 updateMedia called, filtering images...');
    this.filterImagesByVariantName();

    // Nur wenn featured_media existiert, setze active media
    if (!this.currentVariant.featured_media) return;

    const mediaGalleries = document.querySelectorAll(`[id^="MediaGallery-${this.dataset.section}"]`);
    mediaGalleries.forEach(mediaGallery => mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true));

    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector( `[data-media-id="${this.currentVariant.featured_media.id}"]`);
    modalContent.prepend(newMediaModal);
  }

  filterImagesByVariantName() {
    console.log('🚀 filterImagesByVariantName CALLED!');
    
    // Verhindere rekursive Calls
    if (this._isFiltering) {
      console.log('⚠️ Already filtering, skipping to prevent recursion');
      return;
    }
    
    if (!this.currentVariant) {
      console.log('❌ No currentVariant!');
      return;
    }
    
    // WICHTIG: Prüfe ob Variant Picture Metafield aktiviert ist
    const variantPictureEnabled = this.dataset.variantPicture === 'true';
    console.log('🔍 Variant Picture Metafield:', variantPictureEnabled);
    
    if (!variantPictureEnabled) {
      console.log('⚠️ Variant Picture filtering is DISABLED - showing all images');
      this._isFiltering = false;
      return;
    }
    
    // Setze Flag
    this._isFiltering = true;
    
    // Extrahiere das erste Wort des Variantennamens
    const variantName = this.currentVariant.title || '';
    const firstWord = variantName.split(' ')[0].toLowerCase();
    
    console.log('=== VARIANT IMAGE FILTERING ===');
    console.log('Variant name:', variantName);
    console.log('First word:', firstWord);
    console.log('Section ID:', this.dataset.section);
    
    // WICHTIG: Wenn kein firstWord existiert, skip filtering
    if (!firstWord || firstWord.trim() === '') {
      console.log('⚠️ No valid firstWord, skipping filter');
      this._isFiltering = false;
      return;
    }
    
    // Finde alle Media-Galerien für diese Sektion
    const mediaGalleries = document.querySelectorAll(`[id^="MediaGallery-${this.dataset.section}"]`);
    console.log('Found media galleries:', mediaGalleries.length);
    
    if (mediaGalleries.length === 0) {
      console.log('❌ NO GALLERIES FOUND!');
      return;
    }
    
    mediaGalleries.forEach((mediaGallery, index) => {
      console.log(`Processing gallery ${index + 1}...`);
      
      // Finde Slides OHNE Swiper-Check
      const realSlides = mediaGallery.querySelectorAll('.swiper-slide:not(.swiper-slide-duplicate), .product__media-item:not(.swiper-slide-duplicate)');
      console.log('Real slides found:', realSlides.length);
      
      if (realSlides.length === 0) {
        console.log('❌ No slides found in gallery', index + 1);
        return;
      }
      
      let visibleCount = 0;
      
      // Filtere die echten Slides
      realSlides.forEach((slide, slideIndex) => {
        const img = slide.querySelector('img');
        if (!img) {
          console.log(`  Slide ${slideIndex}: No image`);
          return;
        }
        
        const imageAlt = (img.alt || '').toLowerCase();
        const imageSrc = (img.src || '').toLowerCase();
        const fileName = imageSrc.split('/').pop().split('.')[0].toLowerCase();
        
        console.log(`  Slide ${slideIndex}: alt="${imageAlt}", fileName="${fileName}"`);
        
        const shouldShow = firstWord === '' || 
                          imageAlt.includes(firstWord) || 
                          fileName.includes(firstWord);
        
        console.log(`  → shouldShow: ${shouldShow} (firstWord="${firstWord}")`);
        
        if (shouldShow) {
          slide.classList.remove('variant-filtered');
          slide.style.display = '';
          visibleCount++;
          console.log(`  ✅ SHOWING slide ${slideIndex}`);
        } else {
          slide.classList.add('variant-filtered');
          slide.style.display = 'none';
          console.log(`  ❌ HIDING slide ${slideIndex}`);
        }
      });
      
      console.log(`✅ Visible slides: ${visibleCount} of ${realSlides.length}`);
      
        // EINFACHE STRATEGIE: Swiper Refresh wie beim Page Load
        if (mediaGallery.swiper) {
          console.log('🔄 Refreshing Swiper...');
          
          if (mediaGallery.swiper.params.loop) {
            // Einfach: Swiper update + slideTo wie beim Page Load
            setTimeout(() => {
              mediaGallery.swiper.update();
              mediaGallery.swiper.slideTo(0, 0);
              this.updatePagination(mediaGallery);
              console.log('  ✅ Swiper refreshed!');
            }, 100);
          } else {
            mediaGallery.swiper.update();
            mediaGallery.swiper.slideTo(0, 0);
            this.updatePagination(mediaGallery);
          }
        } else {
          console.log('⚠️ No swiper found - Need to be fixed!');
          console.log('🔄 Attempting to find and assign Swiper instance...');
          
          // Versuche Swiper aus window.slider zu holen
          if (window.slider && window.slider['mian_product_slider']) {
            console.log('✅ Found Swiper in window.slider!');
            mediaGallery.swiper = window.slider['mian_product_slider'];
            
            // WICHTIG: Kein rekursiver Call mehr! Stattdessen direkt Loop-Rebuild
            setTimeout(() => {
              console.log('🔄 Rebuilding with found Swiper instance...');
              if (mediaGallery.swiper && mediaGallery.swiper.params && mediaGallery.swiper.params.loop) {
                const swiperInstance = mediaGallery.swiper;
                const swiperWrapper = mediaGallery.querySelector('.swiper-wrapper');
                
                try {
                  // Destroy Loop
                  swiperInstance.params.loop = false;
                  swiperInstance.loopDestroy();
                  
                  // Entferne gefilterte Slides
                  const allSlides = swiperWrapper.querySelectorAll('.swiper-slide');
                  allSlides.forEach(slide => {
                    if (slide.classList.contains('variant-filtered')) {
                      swiperWrapper.removeChild(slide);
                    }
                  });
                  
                  // Re-enable Loop
                  const remainingCount = swiperWrapper.querySelectorAll('.swiper-slide').length;
                  swiperInstance.params.loop = true;
                  swiperInstance.params.loopedSlides = remainingCount;
                  swiperInstance.params.loopAdditionalSlides = Math.max(remainingCount * 5, 15);
                  
                  swiperInstance.loopCreate();
                  swiperInstance.update();
                  swiperInstance.slideTo(0, 0);
                  
                  console.log('✅ Loop rebuilt with found Swiper!');
                } catch(e) {
                  console.log('⚠️ Rebuild failed:', e);
                }
              }
            }, 500);
          } else {
            console.log('❌ Could not find Swiper instance anywhere!');
          }
        }
    });
    
    // Filtere auch die Thumbnails
    const thumbnailGalleries = document.querySelectorAll(`[id^="GalleryThumbnails-${this.dataset.section}"]`);
    
    thumbnailGalleries.forEach(thumbnailGallery => {
      const realThumbSlides = thumbnailGallery.querySelectorAll('.swiper-slide:not(.swiper-slide-duplicate), .thumbnail-list__item:not(.swiper-slide-duplicate)');
      
      if (realThumbSlides.length === 0) return;
      
      let visibleThumbCount = 0;
      
      realThumbSlides.forEach(slide => {
        const img = slide.querySelector('img');
        if (!img) return;
        
        const imageAlt = (img.alt || '').toLowerCase();
        const imageSrc = (img.src || '').toLowerCase();
        const fileName = imageSrc.split('/').pop().split('.')[0].toLowerCase();
        
        const shouldShow = firstWord === '' || 
                          imageAlt.includes(firstWord) || 
                          fileName.includes(firstWord);
        
        if (shouldShow) {
          slide.classList.remove('variant-filtered');
          slide.style.display = '';
          visibleThumbCount++;
        } else {
          slide.classList.add('variant-filtered');
          slide.style.display = 'none';
        }
      });
      
      // Einfacher Thumbnail Refresh
      if (thumbnailGallery.swiper) {
        setTimeout(() => {
          thumbnailGallery.swiper.update();
          thumbnailGallery.swiper.slideTo(0, 0);
          console.log('  ✅ [Thumbs] Refreshed!');
        }, 100);
      }
    });
    
    // Reset Flag am Ende
    this._isFiltering = false;
    console.log('✅ Filtering completed, flag reset');
  }

  updatePagination(mediaGallery) {
    console.log('=== UPDATING PAGINATION ===');
    
    // Finde alle Slides
    const allSlides = mediaGallery.querySelectorAll('.swiper-slide');
    console.log('Total slides found:', allSlides.length);
    
    // Finde alle Pagination-Container
    const paginationContainers = mediaGallery.querySelectorAll('.swiper-pagination, .main-swiper-pagination');
    console.log('Pagination containers found:', paginationContainers.length);
    
    paginationContainers.forEach((container, containerIndex) => {
      console.log(`Processing container ${containerIndex + 1}:`, container.className);
      
      // Finde alle Bullets in diesem Container
      const bullets = container.querySelectorAll('.swiper-pagination-bullet');
      console.log(`  Bullets in container: ${bullets.length}`);
      
      bullets.forEach((bullet, bulletIndex) => {
        // Finde den entsprechenden Slide
        const correspondingSlide = allSlides[bulletIndex];
        const isSlideFiltered = correspondingSlide && correspondingSlide.classList.contains('variant-filtered');
        
        console.log(`  Bullet ${bulletIndex + 1}:`, {
          slideExists: !!correspondingSlide,
          isSlideFiltered: isSlideFiltered,
          slideClasses: correspondingSlide ? correspondingSlide.className : 'none'
        });
        
        if (isSlideFiltered) {
          bullet.style.display = 'none';
          bullet.classList.add('variant-filtered');
          console.log(`    → Bullet ${bulletIndex + 1} HIDDEN`);
        } else {
          bullet.style.display = '';
          bullet.classList.remove('variant-filtered');
          console.log(`    → Bullet ${bulletIndex + 1} VISIBLE`);
        }
      });
    });
    
    // Aktualisiere Swiper-Pagination
    if (mediaGallery.swiper && mediaGallery.swiper.pagination) {
      mediaGallery.swiper.pagination.update();
    }
    
    // Zusätzliche Aktualisierung für dynamisch generierte Bullets
    setTimeout(() => {
      this.updatePaginationBullets(mediaGallery);
    }, 50);
    
    // Aktualisiere Swiper-Konfiguration für gefilterte Slides
    if (mediaGallery.swiper) {
      // Zähle sichtbare Slides
      const visibleSlides = mediaGallery.querySelectorAll('.swiper-slide:not(.variant-filtered)');
      const totalSlides = mediaGallery.querySelectorAll('.swiper-slide');
      
      console.log(`Visible slides: ${visibleSlides.length} of ${totalSlides.length}`);
      
      // Konfiguriere Swiper um gefilterte Slides zu überspringen
      const filteredSlides = mediaGallery.querySelectorAll('.swiper-slide.variant-filtered');
      console.log(`Filtering ${filteredSlides.length} slides`);
      
      // Setze gefilterte Slides auf display: none und entferne sie aus der Swiper-Logik
      filteredSlides.forEach(slide => {
        slide.style.display = 'none';
        slide.style.visibility = 'hidden';
        slide.style.opacity = '0';
        slide.style.pointerEvents = 'none';
      });
      
      // Aktualisiere Swiper-Einstellungen
      if (visibleSlides.length === 0) {
        // Keine sichtbaren Slides - deaktiviere Navigation
        mediaGallery.swiper.allowTouchMove = false;
        mediaGallery.swiper.allowSlideNext = false;
        mediaGallery.swiper.allowSlidePrev = false;
      } else {
        // Aktiviere Navigation für sichtbare Slides
        mediaGallery.swiper.allowTouchMove = true;
        mediaGallery.swiper.allowSlideNext = true;
        mediaGallery.swiper.allowSlidePrev = true;
        
        // Finde den ersten sichtbaren Slide
        const firstVisibleIndex = Array.from(totalSlides).findIndex(slide => !slide.classList.contains('variant-filtered'));
        if (firstVisibleIndex !== -1) {
          mediaGallery.swiper.slideTo(firstVisibleIndex, 0);
        }
      }
      
      // Konfiguriere Swiper um gefilterte Slides zu überspringen
      if (mediaGallery.swiper) {
        // Erstelle eine Liste der sichtbaren Slide-Indizes
        const visibleSlideIndices = [];
        mediaGallery.swiper.slides.forEach((slide, index) => {
          if (!slide.classList.contains('variant-filtered')) {
            visibleSlideIndices.push(index);
          }
        });
        
        console.log('Visible slide indices:', visibleSlideIndices);
        
        // Speichere die ursprünglichen Navigation-Funktionen
        if (!mediaGallery.swiper.originalSlideToNext) {
          mediaGallery.swiper.originalSlideToNext = mediaGallery.swiper.slideToNext;
        }
        if (!mediaGallery.swiper.originalSlideToPrev) {
          mediaGallery.swiper.originalSlideToPrev = mediaGallery.swiper.slideToPrev;
        }
        
        // Überschreibe die Navigation-Funktionen
        mediaGallery.swiper.slideToNext = function() {
          const currentIndex = this.activeIndex;
          const currentVisibleIndex = visibleSlideIndices.indexOf(currentIndex);
          
          if (currentVisibleIndex !== -1 && currentVisibleIndex < visibleSlideIndices.length - 1) {
            const nextVisibleIndex = visibleSlideIndices[currentVisibleIndex + 1];
            this.slideTo(nextVisibleIndex);
            console.log(`Next: ${currentIndex} -> ${nextVisibleIndex}`);
          }
        };
        
        mediaGallery.swiper.slideToPrev = function() {
          const currentIndex = this.activeIndex;
          const currentVisibleIndex = visibleSlideIndices.indexOf(currentIndex);
          
          if (currentVisibleIndex !== -1 && currentVisibleIndex > 0) {
            const prevVisibleIndex = visibleSlideIndices[currentVisibleIndex - 1];
            this.slideTo(prevVisibleIndex);
            console.log(`Prev: ${currentIndex} -> ${prevVisibleIndex}`);
          }
        };
        
        // Überschreibe auch die Touch-Navigation
        const originalOnTouchEnd = mediaGallery.swiper.onTouchEnd;
        mediaGallery.swiper.onTouchEnd = function() {
          // Rufe die ursprüngliche Funktion auf
          if (originalOnTouchEnd) {
            originalOnTouchEnd.call(this);
          }
          
          // Prüfe ob der aktuelle Slide gefiltert ist
          if (this.slides[this.activeIndex] && this.slides[this.activeIndex].classList.contains('variant-filtered')) {
            // Gehe zum nächsten sichtbaren Slide
            this.slideToNext();
          }
        };
        
        // Überschreibe auch die Pagination-Klicks
        const paginationBullets = mediaGallery.querySelectorAll('.swiper-pagination-bullet');
        paginationBullets.forEach((bullet, index) => {
          bullet.addEventListener('click', (e) => {
            e.preventDefault();
            const slideIndex = index;
            if (!mediaGallery.swiper.slides[slideIndex].classList.contains('variant-filtered')) {
              mediaGallery.swiper.slideTo(slideIndex);
            }
          });
        });
      }
      
      // Aktualisiere Swiper
      mediaGallery.swiper.update();
    }
  }

  updatePaginationBullets(mediaGallery) {
    console.log('=== UPDATING PAGINATION BULLETS (DELAYED) ===');
    
    // Finde alle Slides
    const allSlides = mediaGallery.querySelectorAll('.swiper-slide');
    
    // Finde alle Bullets (auch dynamisch generierte)
    const allBullets = mediaGallery.querySelectorAll('.swiper-pagination-bullet');
    console.log('Found bullets after delay:', allBullets.length);
    
    allBullets.forEach((bullet, index) => {
      const correspondingSlide = allSlides[index];
      const isSlideFiltered = correspondingSlide && correspondingSlide.classList.contains('variant-filtered');
      
      if (isSlideFiltered) {
        bullet.style.display = 'none';
        bullet.classList.add('variant-filtered');
        console.log(`Delayed update: Bullet ${index + 1} HIDDEN`);
      } else {
        bullet.style.display = '';
        bullet.classList.remove('variant-filtered');
        console.log(`Delayed update: Bullet ${index + 1} VISIBLE`);
      }
    });
  }

  showAllImages() {
    console.log('Showing all images - no variant selected');
    
    // Nur alle Bilder anzeigen wenn KEINE Variante ausgewählt ist
    if (this.currentVariant) {
      console.log('Variant is selected, not showing all images');
      return;
    }
    
    // Finde alle Media-Galerien für diese Sektion
    const mediaGalleries = document.querySelectorAll(`[id^="MediaGallery-${this.dataset.section}"]`);
    
    mediaGalleries.forEach(mediaGallery => {
      // Finde alle Slides in der Galerie
      const slides = mediaGallery.querySelectorAll('.swiper-slide, .product__media-item');
      
      slides.forEach(slide => {
        // Zeige alle Bilder an
        slide.style.display = '';
        slide.style.visibility = '';
        slide.style.opacity = '';
        slide.style.pointerEvents = '';
        slide.classList.remove('variant-filtered');
      });
      
      // Aktualisiere den Swiper
      if (mediaGallery.swiper) {
        // Aktiviere Navigation wieder
        mediaGallery.swiper.allowTouchMove = true;
        mediaGallery.swiper.allowSlideNext = true;
        mediaGallery.swiper.allowSlidePrev = true;
        
        // Stelle die ursprünglichen Navigation-Funktionen wieder her
        if (mediaGallery.swiper.originalSlideToNext) {
          mediaGallery.swiper.slideToNext = mediaGallery.swiper.originalSlideToNext;
        }
        if (mediaGallery.swiper.originalSlideToPrev) {
          mediaGallery.swiper.slideToPrev = mediaGallery.swiper.originalSlideToPrev;
        }
        
        mediaGallery.swiper.update();
        // Zeige alle Pagination-Bullets wieder an
        this.showAllPagination(mediaGallery);
      }
    });
    
    // Zeige auch alle Thumbnails an
    const thumbnailGalleries = document.querySelectorAll(`[id^="GalleryThumbnails-${this.dataset.section}"]`);
    
    thumbnailGalleries.forEach(thumbnailGallery => {
      const thumbnailSlides = thumbnailGallery.querySelectorAll('.swiper-slide, .thumbnail-list__item');
      
      thumbnailSlides.forEach(slide => {
        slide.style.display = '';
        slide.classList.remove('variant-filtered');
      });
      
      // Aktualisiere den Thumbnail-Swiper
      if (thumbnailGallery.swiper) {
        thumbnailGallery.swiper.update();
      }
    });
  }

  showAllPagination(mediaGallery) {
    // Zeige alle Pagination-Bullets wieder an
    const paginationElements = mediaGallery.querySelectorAll('.swiper-pagination, .main-swiper-pagination, .swiper-pagination-bullet');
    
    paginationElements.forEach(pagination => {
      if (pagination.classList.contains('swiper-pagination-bullet')) {
        // Einzelner Bullet
        pagination.style.display = '';
        pagination.classList.remove('variant-filtered');
      } else {
        // Pagination-Container
        const bullets = pagination.querySelectorAll('.swiper-pagination-bullet');
        bullets.forEach(bullet => {
          bullet.style.display = '';
          bullet.classList.remove('variant-filtered');
        });
      }
    });
    
    // Aktualisiere Swiper-Pagination
    if (mediaGallery.swiper && mediaGallery.swiper.pagination) {
      mediaGallery.swiper.pagination.update();
    }
    
    // Aktiviere Swiper-Navigation wieder
    if (mediaGallery.swiper) {
      mediaGallery.swiper.allowTouchMove = true;
      mediaGallery.swiper.allowSlideNext = true;
      mediaGallery.swiper.allowSlidePrev = true;
      mediaGallery.swiper.update();
    }
    
    // Zusätzliche Aktualisierung für dynamisch generierte Bullets
    setTimeout(() => {
      this.updatePaginationBullets(mediaGallery);
    }, 50);
  }


  updateURL() {
    console.log('🔗 updateURL called');
    console.log('🔗 currentVariant:', this.currentVariant);
    console.log('🔗 dataset.updateUrl:', this.dataset.updateUrl);
    console.log('🔗 dataset.url:', this.dataset.url);
    
    if (!this.currentVariant) {
      console.log('❌ updateURL: No currentVariant!');
      return;
    }
    
    if (this.dataset.updateUrl === 'false') {
      console.log('❌ updateURL: updateUrl is false!');
      return;
    }
    
    const newUrl = `${this.dataset.url}?variant=${this.currentVariant.id}`;
    console.log('✅ Updating URL to:', newUrl);
    window.history.replaceState({ }, '', newUrl);
    console.log('✅ URL updated!');
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
    console.log(this.options, this.currentVariant);
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html')
        const destination = document.getElementById(`price-${this.dataset.section}`);
        const source = html.getElementById(`price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
        if (source && destination) destination.innerHTML = source.innerHTML;

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove('visibility-hidden');
        this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }
}

customElements.define('variant-radios', VariantRadios);

class VariantPickerImages extends VariantSelects {
  constructor() {
    super();
  }
  
  connectedCallback() {
    super.connectedCallback();
    
    // Registriere Change-Listener auf allen Radio Inputs
    const radioInputs = this.querySelectorAll('input[type="radio"]');
    radioInputs.forEach(radio => {
      radio.addEventListener('change', () => {
        console.log('📸 Radio input changed:', radio.value);
        // Rufe onVariantChange DIREKT auf statt Event zu dispatchen
        this.onVariantChange();
      });
    });
  }

  updateOptions() {
    const radioInputs = Array.from(this.querySelectorAll('input[type="radio"]:checked'));
    this.options = radioInputs.map(input => input.value);
  }
}

customElements.define('variant-picker-images', VariantPickerImages);

// Globale Debugging-Funktionen für Varianten-Bildfilterung
window.debugVariantFiltering = function() {
  console.log('=== VARIANT FILTERING DEBUG ===');
  
  // Finde alle Variant-Selects auf der Seite
  const variantSelects = document.querySelectorAll('variant-selects, variant-radios, variant-picker-images');
  
  variantSelects.forEach((variantSelect, index) => {
    console.log(`Variant Select ${index + 1}:`, variantSelect);
    console.log('Current variant:', variantSelect.currentVariant);
    console.log('Options:', variantSelect.options);
    
    if (variantSelect.currentVariant) {
      const variantName = variantSelect.currentVariant.title || '';
      const firstWord = variantName.split(' ')[0].toLowerCase();
      console.log('Variant name:', variantName);
      console.log('First word:', firstWord);
    }
  });
  
  // Finde alle Bilder auf der Seite
  const allImages = document.querySelectorAll('img');
  console.log('Total images found:', allImages.length);
  
  // Finde alle Pagination-Bullets
  const allBullets = document.querySelectorAll('.swiper-pagination-bullet');
  console.log('Total pagination bullets found:', allBullets.length);
  
  allImages.forEach((img, index) => {
    const alt = img.alt || '';
    const src = img.src || '';
    const fileName = src.split('/').pop().split('.')[0].toLowerCase();
    const isFiltered = img.closest('.variant-filtered') !== null;
    
    console.log(`Image ${index + 1}:`, {
      alt: alt,
      fileName: fileName,
      src: src,
      isFiltered: isFiltered,
      parentElement: img.parentElement
    });
  });
};

window.testVariantFiltering = function(variantName) {
  console.log('=== TESTING VARIANT FILTERING ===');
  console.log('Testing with variant name:', variantName);
  
  const firstWord = variantName.split(' ')[0].toLowerCase();
  console.log('First word:', firstWord);
  
  // Finde alle Bilder
  const allImages = document.querySelectorAll('img');
  
  allImages.forEach((img, index) => {
    const alt = (img.alt || '').toLowerCase();
    const src = (img.src || '').toLowerCase();
    const fileName = src.split('/').pop().split('.')[0].toLowerCase();
    
    const shouldShow = firstWord === '' || 
                      alt.includes(firstWord) || 
                      src.includes(firstWord) ||
                      fileName.includes(firstWord);
    
    console.log(`Image ${index + 1}:`, {
      alt: alt,
      fileName: fileName,
      shouldShow: shouldShow,
      matches: {
        alt: alt.includes(firstWord),
        src: src.includes(firstWord),
        fileName: fileName.includes(firstWord)
      }
    });
  });
};

// Spezielle Debugging-Funktion für Pagination
window.debugPaginationFiltering = function() {
  console.log('=== PAGINATION FILTERING DEBUG ===');
  
  // Finde alle Media-Galerien
  const mediaGalleries = document.querySelectorAll('[id^="MediaGallery-"]');
  
  mediaGalleries.forEach((gallery, galleryIndex) => {
    console.log(`Gallery ${galleryIndex + 1}:`, gallery.id);
    
    // Finde alle Slides
    const slides = gallery.querySelectorAll('.swiper-slide');
    console.log(`  Total slides: ${slides.length}`);
    
    // Finde alle Pagination-Bullets
    const bullets = gallery.querySelectorAll('.swiper-pagination-bullet');
    console.log(`  Total bullets: ${bullets.length}`);
    
    // Prüfe gefilterte Slides
    const filteredSlides = gallery.querySelectorAll('.swiper-slide.variant-filtered');
    console.log(`  Filtered slides: ${filteredSlides.length}`);
    
    // Prüfe gefilterte Bullets
    const filteredBullets = gallery.querySelectorAll('.swiper-pagination-bullet.variant-filtered');
    console.log(`  Filtered bullets: ${filteredBullets.length}`);
    
    // Swiper-Status
    if (gallery.swiper) {
      console.log(`  Swiper active: ${gallery.swiper.active}`);
      console.log(`  Swiper allowTouchMove: ${gallery.swiper.allowTouchMove}`);
      console.log(`  Swiper allowSlideNext: ${gallery.swiper.allowSlideNext}`);
      console.log(`  Swiper allowSlidePrev: ${gallery.swiper.allowSlidePrev}`);
    }
  });
};

// Finale Debugging-Funktion für die komplette Filterung
window.debugCompleteFiltering = function() {
  console.log('=== COMPLETE FILTERING DEBUG ===');
  
  // Finde alle Variant-Selects
  const variantSelects = document.querySelectorAll('variant-selects, variant-radios, variant-picker-images');
  console.log('Variant selects found:', variantSelects.length);
  
  variantSelects.forEach((variantSelect, index) => {
    console.log(`\n--- Variant Select ${index + 1} ---`);
    console.log('Current variant:', variantSelect.currentVariant);
    
    if (variantSelect.currentVariant) {
      const variantName = variantSelect.currentVariant.title || '';
      const firstWord = variantName.split(' ')[0].toLowerCase();
      console.log('Variant name:', variantName);
      console.log('First word:', firstWord);
      
      // Finde Media-Galerien für diese Sektion
      const mediaGalleries = document.querySelectorAll(`[id^="MediaGallery-${variantSelect.dataset.section}"]`);
      console.log('Media galleries found:', mediaGalleries.length);
      
      mediaGalleries.forEach((gallery, galleryIndex) => {
        console.log(`\n  Gallery ${galleryIndex + 1}: ${gallery.id}`);
        
        // Prüfe Slides
        const slides = gallery.querySelectorAll('.swiper-slide');
        const filteredSlides = gallery.querySelectorAll('.swiper-slide.variant-filtered');
        const visibleSlides = gallery.querySelectorAll('.swiper-slide:not(.variant-filtered)');
        console.log(`  Slides: ${slides.length} total, ${filteredSlides.length} filtered, ${visibleSlides.length} visible`);
        
        // Prüfe Bullets
        const bullets = gallery.querySelectorAll('.swiper-pagination-bullet');
        const filteredBullets = gallery.querySelectorAll('.swiper-pagination-bullet.variant-filtered');
        console.log(`  Bullets: ${bullets.length} total, ${filteredBullets.length} filtered`);
        
        // Zeige Details für alle Slides
        slides.forEach((slide, slideIndex) => {
          const img = slide.querySelector('img');
          const isFiltered = slide.classList.contains('variant-filtered');
          if (img) {
            const alt = img.alt || '';
            const src = img.src || '';
            const fileName = src.split('/').pop().split('.')[0].toLowerCase();
            console.log(`    Slide ${slideIndex + 1}: ${isFiltered ? '❌ FILTERED' : '✅ VISIBLE'} - alt="${alt}", fileName="${fileName}"`);
          }
        });
      });
    } else {
      console.log('No variant selected - should show all images');
    }
  });
};

// Test-Funktion um manuell eine Variante zu setzen
window.testVariantSelection = function(variantTitle) {
  console.log('=== TESTING VARIANT SELECTION ===');
  console.log('Testing with variant:', variantTitle);
  
  const variantSelects = document.querySelectorAll('variant-selects, variant-radios, variant-picker-images');
  variantSelects.forEach((variantSelect, index) => {
    console.log(`\nTesting variant select ${index + 1}`);
    
    // Simuliere Variantenauswahl
    const mockVariant = {
      title: variantTitle,
      id: 'test-' + Date.now(),
      options: [variantTitle.split(' ')[0]]
    };
    
    variantSelect.currentVariant = mockVariant;
    variantSelect.filterImagesByVariantName();
    
    console.log('Filtering applied for variant:', variantTitle);
  });
};

// Test-Funktion für Navigation
window.testNavigation = function() {
  console.log('=== TESTING NAVIGATION ===');
  
  const mediaGalleries = document.querySelectorAll('[id^="MediaGallery-"]');
  mediaGalleries.forEach((gallery, index) => {
    console.log(`\nGallery ${index + 1}: ${gallery.id}`);
    
    if (gallery.swiper) {
      console.log('Swiper active:', gallery.swiper.active);
      console.log('Current slide index:', gallery.swiper.activeIndex);
      console.log('Total slides:', gallery.swiper.slides.length);
      
      // Teste Navigation
      console.log('Testing slideToNext...');
      gallery.swiper.slideToNext();
      
      setTimeout(() => {
        console.log('After slideToNext - Current index:', gallery.swiper.activeIndex);
      }, 100);
    }
  });
};

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then(response => response.text())
        .then(text => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('product-recommendations');

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }

          if (!this.querySelector('slideshow-component') && this.classList.contains('complementary-products')) {
            this.remove();
          }

          if (html.querySelector('.grid__item')) {
            this.classList.add('product-recommendations--loaded');
          }
        })
        .catch(e => {
          console.error(e);
        });
    }

    new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 400px 0px'}).observe(this);
  }
}

customElements.define('product-recommendations', ProductRecommendations);

(function(){
  var megaMenuSwiper = new Swiper('.mega-menu__content-slides.swiper', {
      slidesPerView: 4,
      spaceBetween: 24,
      breakpoints: {
      1200: {
        slidesPerView: 6
      }
    }
  })
  var slideshow = document.querySelector('.slideshow__slides')
  var slideshowText = document.querySelector('.slideshow__text_slides')
    var nextEl = slideshow.querySelector('button.slider-button.slider-button--next')
    var prevEl = slideshow.querySelector('button.slider-button.slider-button--prev')
    var slideshowSwiper = new Swiper(slideshow, {
      loop: true,
      autoplay: {
          delay: parseInt(custom.slider_delay, 10),
      },
      navigation: {
        nextEl,
        prevEl
      }
    })
    var slideshowTextSlider = new Swiper(slideshowText, {
      loop: true,
      slidesPerView: 1,
      effect: 'fade',
      allowTouchMove: false,
      fadeEffect: {
        crossFade: true
      }
    })
  slideshowSwiper.on('slideChange', function () {
    var activeSlide = slideshowSwiper.activeIndex
    slideshowTextSlider.slideTo(activeSlide)
  })
})()